import PropTypes from 'prop-types';

import { RENDER_TYPE_MOSAIC } from '@/common/constants';
import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';

export const ProductsTableContextDefaultProps = {
  ...ChildrenDefaultProps,
  tableContainerRef: null,
  renderType: RENDER_TYPE_MOSAIC,
};

export const ProductsTableContextPropTypes = {
  ...ChildrenPropTypes,
  tableContainerRef: PropTypes.shape({
    current: PropTypes.instanceOf(HTMLElement),
  }),
  renderType: PropTypes.string,
};
